import { render } from "./termsinput.vue?vue&type=template&id=6dd60f13&scoped=true"
import script from "./termsinput.vue?vue&type=script&lang=js"
export * from "./termsinput.vue?vue&type=script&lang=js"

import "./termsinput.vue?vue&type=style&index=0&id=6dd60f13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd60f13"]])

export default __exports__